export class ClientSearchModel {
  id: string;
  name: string;
  status: string;
  activeProgramCount: number;
}
